/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Gift } from "models/Gift";
import {
  OrderLine,
  OrderLineChannel,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RecordController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }


  updateDeferenceStatus = ({gift, id}: {id: string, gift: Gift}, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/records/${id}/deferences`,
      method: "PUT",
      body: {
        gift: gift
      },
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  getDeferenceInfo = (
    { recordId, articleCode, ...query }: {
      recordId: string;
      articleCode: string;
    },
    params: RequestParams = {},
  ) => {

    const MOCKED_API = false
    if (MOCKED_API) {
      const orderline: OrderLine = {
        articleDescription: '',
        amount: 1,
        category: '',
        channel: OrderLineChannel.PROCESSING,
        comments: 'any comments',
        dedicatory: '',
        client: {
          identifier: '',
        },
        code: '',
        erpId: 0,
        observations: '',
        supplier: '',
        idSupplier: '',
      };
      return Promise.resolve(orderline);
    }

    return this.http.request<OrderLine, void>({
      path: `/records/${recordId}/deferences/${articleCode}`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  }
}
